<template>
    <div id="attendancelistview">
        <div class="container admin-wrap">
            <div class="row header mb-5">
                <div class="col-lg-7">
                    <h3 class="text-left mb-3">{{lang('Attendance List View')}} ( {{currentDateWithAlphabet}} )</h3>
                </div>
                <div class="col-lg-5">
                    <div class="row">
                        <el-select v-model="ddlClass" :placeholder="lang('Select Class')" class="pro-edt-select"
                                   @change="Load()" style="margin-left: auto!important;">
                            <el-option
                                    v-for="item in ddlClassList"
                                    :key="item.PK_Class_ID"
                                    :label="item.CLS_ClassName + ' (' + item.CLS_Batch + ')'"
                                    :value="item.PK_Class_ID">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="pb-5">
                <div class="empty-list_image" v-if="ddlClass === ''">
                    <strong>
                        {{lang('Please select Class...')}}
                    </strong>
                    <img src="../assets/attendance.jpg"/>
                </div>
                <div class="empty-list_image" v-if="studentListInt.length < 1 && ddlClass !== ''">
                    <strong>
                        {{lang('No Student Found...')}}
                    </strong>
                    <img src="../assets/attendance.jpg"/>
                </div>
                <div v-if="studentListInt.length > 0 && ddlClass !== ''" class="responsive-table">
                    <table class="attTable">
                        <tr>
                            <th>{{lang('Student Name')}}</th>
                            <th>{{lang('Attendance')}}</th>
                            <th>{{lang('Remarks')}}</th>
                            <th>{{lang('Parents Contact')}}</th>
                            <th>{{lang('Pickup Mode')}}</th>
                            <th>{{lang('ECA')}}</th>
                        </tr>
                        <tr v-for="item in studentListInt" :key="item.Student_ID + item.markingStatus">
                            <td><label class="lblStudentName">{{item.Student_Name}}</label></td>
                            <td><label class="lblStudentName">{{item.markingStatus}}</label></td>
                            <td><label class="lblStudentName">{{item.remarks}}</label></td>
                            <td>
                                <select class="parentsMobileNo">
                                    <option v-if="item.fatherMobile !== ''">{{lang('Father')}} - {{ item.fatherMobile }}</option>
                                    <option v-if="item.fatherMobile === ''">{{lang('Father')}} - {{lang('Nil')}}</option>
                                    <option v-if="item.motherMobile !== ''">{{lang('Mother')}} - {{ item.motherMobile }}</option>
                                    <option v-if="item.motherMobile === ''">{{lang('Mother')}} - {{lang('Nil')}}</option>
                                </select>
                           
                            </td>
                            <td v-if="item.busOutNo"><label class="lblBusNo">{{item.busOutNo}}</label></td>
                            <td v-if="!item.busOutNo"><label class="lblBusNo">-</label></td>
                            <td><label class="lblEcaName">{{item.ecaName}}</label></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import DataSource from "../data/datasource";
    import {lang} from '../locale/index';
    import moment from 'moment';

    export default {
        name: "AttendanceListView",
        data() {
            return {
                ddlClassList: [],
                ddlClass: '',
                studentListInt: [],
                studentList: [{
                    prop: "First_Name",
                    label: "Student Name"
               
                }],
            };
        },
        async created() {
          this.LoadForClass();
        },
        async mounted() {
        },
        computed: {
            currentDateWithAlphabet() {
                return moment().format("DD MMM YYYY");
            },
        },
        methods: {
            lang,
            async LoadForClass() {
                try {
                    const response = await DataSource.shared.getAttendanceListViewClass();
                    if (response) {
                        if (response.code === '88') {
                            window.location.replace('/');
                        } else if (response.code === '99') {
                            console.log('Get Attendance List View Class: Error');
                        } else if (response.code === '2') {
                            this.$notify({
                                title: 'No Record',
                                message: 'No Record Found...'
                            });
                        } else {
                            this.ddlClassList = response.Table;
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async Load() {
                try {
                    if (this.ddlClass === '') {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please select class')
                        });
                    } else {
                        this.$vs.loading();

                        this.studentList = [];

                        const response = await DataSource.shared.LoadAttendanceListWithMode(this.ddlClass, 'GroupClasName');
                        if (response) {
                            if (response.code === '2') {
                                this.$notify({
                                    title: 'No Record',
                                    message: 'No Record Found'
                                });
                            } else if (response.code === '88') {
                                window.location.replace('/');
                            } else if (response.code === '99') {
                                console.log('Load Attendance List With Mode: Error');
                            } else {
                                this.studentListInt = response.Table;
                            }
                        }

                        this.$vs.loading.close();
                    }
                } catch (e) {
                    this.results = e;
                }
            },
        }
    };
</script>
<style scoped>
    .attTable {
        width: 100%;
        margin-top: 20px;
    }

    .attTable td, .attTable th, .attTable label {
        text-align: center;
        padding: 10px;
    }

    .attTable tr:nth-child(even) {
        background: #fff;
    }

    .ddlClass {
        display: inline;
        width: auto;
    }

    .lblClass {
        display: inline !important;
        padding: 20px;
    }

    input[type='checkbox'] {
        width: 30px;
        height: 30px;
        background: white;
        border-radius: 5px;
        border: 2px solid #555;
    }

    .searchingArea {
        text-align: left;
    }

    .checkbox_wrapper {
        min-width: 100%;
    }

    .lblCheckBox {
        width: 100%;
    }

    .parentsMobileNo {
        background-color: #FFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        outline: 0;
        padding: 0 15px;
    }

    .attendance-search .el-select {
        margin-left: 10px !important;
    }

    .taTempImport {
        width: 100%;
        border-radius: 5px;
        /* box-shadow: 10px 10px 5px grey; */
        border: 0px;
        background: #ededed;
    }

    .tempImportButtonArea {
        margin: 10px 0 0 0;
    }

    .lblBusNo, .lblStudentName, .lblEcaName {
        font-weight: normal !important;
    }

    .divSortBy {
        text-align: right;
    }
    .divSortBy label {
        display: inline !important;
        margin-right: 10px;
    }
</style>